import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import auth from '../../../plugins/routes/auth';
import Header from './Header'
import cookie from 'js-cookie';
import { Select, Row, Col } from 'antd';

import koczerLogo from "../../../assets/img/logo/koczer_logo_white.svg"

// const items = [
//   {
//     label: 'Türkçe',
//     key: '1',
//   },
//   {
//     label: 'English',
//     key: '2',
//   },
// ];


class AuthLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  componentWillMount() {
    const token = cookie.get('access_token');
    if (token) {
      window.location.pathname = '/app/trips';
    }else{

    }
  }

  render() {
    return (
      <div className="auth">
        <Row>
          <Col xs="24" sm="24" md="24" lg="24">
            <Header path={window.location.pathname.split("/")[2]} />
          </Col>
        </Row>
        <Row className="auth-content-container">
          <Col>
            <Switch>
              {auth.routes.map((route, key) => {
                return <Route
                  path={`${auth.path}${route.path}`}
                  component={route.component}
                  key={key}
                />;
              })}
              <Redirect from="/auth" to="/auth/sign-in" />
            </Switch>
          </Col>
        </Row>
        <Row className='footer'>
          <Col xs="24" sm="24" md="24" lg="24">
            <img src={koczerLogo} alt="" />
          </Col>
          <Col xs="8" sm="8" md="24" lg="24" style={{ textAlign: "center" }}>
            <a href="https://www.koczer.com/kisisel-verilerin-korunmasi" target="_blank" rel="noopener noreferrer">Kişisel Verilerin Korunması</a>
          </Col>

          <Col xs="8" sm="8" md="24" lg="24">
            <Select
              defaultValue="TR"
              options={[
                { value: 'TR', label: 'Türkçe' },
                { value: 'EN', label: 'English' },
              ]}
            />
          </Col>
        </Row>
      </div >
    )
  }
}

const mapStateToProps = ({ auth }) => ({ ...auth });
export default connect(mapStateToProps)(AuthLayout);


// WEBPACK FOOTER //
// ./src/components/Auth/Layout/Layout.js